module.exports = __webpack_public_path__ + "img/accordion-arr-icon.87b93f30.svg";